export default "__VITE_ASSET__3c1a63f5__"